import { useState } from 'react'
import './App.css'
import Nav from './Components/common/Nav';
import HomePage from './pages/HomePage'
import FooterBar from './Components/common/Footer'
import { Route, Routes } from 'react-router';
// import { BrowserRouter as Router } from "react-router";
import CategoriesPage from './pages/CategoriesPage';
import TreatmentsPage from './pages/TreatmentsHomePage';
import GalleryPage from './pages/GalleryPage';
import PackagesPage from './pages/PackagesHomePage';
import AboutUsPage from './pages/AboutUsPage';
import ContactUsPage from './pages/ContactUsPage';
import TreatmentDetailsPage from './pages/TreatmentDetailsPage';
import QuickScroller from './Components/common/QuickScroller';
import LoyaltyCardsPage from './pages/LoyaltyCardsPage';
import LoyaltyCardDetailsPage from './pages/LoyaltyCardDetailsPage';

function App() {

  return (
    <>
      <div className='scroll-smooth'>
        <Nav />
        <Routes >
          <Route path='/*' element={<HomePage />} />
          <Route path='/Home' element={<HomePage />} />
          <Route path='/Categories' element={<CategoriesPage />} />
          <Route path='/Treatments/:Category' element={<TreatmentsPage />} />
          <Route path='/Treatments' element={<TreatmentsPage />} />
          <Route path='/Treatment/:TreatmentName' element={<TreatmentDetailsPage />} />
          {/* <Route path='/Loyalty' element={<LoyaltyCardsPage />} /> */}
          <Route path='/Loyalty/:LoyaltyCardId' element={<LoyaltyCardDetailsPage />} />
          <Route path='/Gallery' element={<GalleryPage />} />
          <Route path='/Packages' element={<PackagesPage />} />
          <Route path='/Contact-us' element={<ContactUsPage />} />
          <Route path='/About-us' element={<AboutUsPage />} />
        </Routes>
        <FooterBar />
        <QuickScroller />
      </div>
    </>
  )
}

export default App
